import type { MenuTreeRowProps } from "./menu-tree-row.type";

import { Typography } from "antd";

import "./menu-tree-row.style.less";

const { Text } = Typography;

export const MenuTreeRow = <Data extends object>({
  item,
  renderTitle,
  renderDescription,
  renderExtra,
}: MenuTreeRowProps<Data>) => {
  return (
    <div className="menu-tree-row">
      <div className="menu-tree-row-main-infos">
        <div className="menu-tree-row-title">
          {renderTitle ? (
            renderTitle(item)
          ) : (
            <Text ellipsis>{`${item.title}`}</Text>
          )}
        </div>
        {renderDescription ? (
          <div className="menu-tree-row-description">
            {renderDescription(item)}
          </div>
        ) : null}
      </div>
      {renderExtra ? (
        <div className="menu-tree-row-extra">{renderExtra(item)}</div>
      ) : null}
    </div>
  );
};
